import { useSelector } from 'react-redux';
import type { IReduxState } from '../../../../configureStore';
import type { IPractitioner } from '../../../interfaces/practitioner';
import type { ISearchFilter } from './RequestsListHeader';
import { getDisplayName } from '../../../../../common/utils/getDisplayName';
import { translateKey } from '../../../../translate';
import { useAbortableFetch } from '../../../../utils/hooks/useAbortableFetch';
import { DropdownAsyncLoadInput } from '../../../fields/DropdownAsyncLoad';

export interface IRequestListPractitionerFilterProps {
    onSearchFilterChange: (searchFilter: ISearchFilter) => Promise<void>;
    searchFilter: ISearchFilter;
}

export function RequestListPractitionerFilter(props: IRequestListPractitionerFilterProps) {
    const abortableFetch = useAbortableFetch();
    const organizationId = useSelector((state: IReduxState) => state.authentication.organizationId);

    return (
        <DropdownAsyncLoadInput
            loadOptions={async (searchTerm) => await loadPractitioner(searchTerm)}
            onChange={async (value) =>
                await props.onSearchFilterChange({ ...props.searchFilter, practitionerId: value })
            }
            placeholder={translateKey('common.filterOnPractitioner')}
            value={props.searchFilter.practitionerId}
        />
    );

    async function loadPractitioner(text: string) {
        const result = await abortableFetch.fetchJson('/api/practitioners/list', 'POST', {
            filters: {
                organizationId,
                name: text,
            },
            sortBy: 'name',
        });

        return result.json.items.map((practitioner: IPractitioner) => {
            return { value: practitioner.id, label: getDisplayName(practitioner) };
        });
    }
}
